<template>
  <div ref="header" class="header" data-aos="appear" data-aos-anchor-placement="bottom-bottom">
    <div class="header-container">
      <div class="seperator-wrapper bar-glow">
        <div class="seperator left" :style="glitchStyle1"></div>
      </div>
      <div class="title-header text-glow">
        <text-glitch :parentGlitch="parentGlitch" :text="title">{{title}}</text-glitch>
      </div>
      <div class="seperator-wrapper bar-glow">
        <div class="seperator right" :style="glitchStyle2"></div>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * Shows the header for each section
 */
import StoreUtils from "@/scripts/utils/store"
import RandomUtils from "@/scripts/utils/random"
import TextGlitch from "./text-glitch"
export default {
  components: {
    TextGlitch
  },
  props: {
    title: String,
    parentGlitch: Boolean
  },
  watch: {
    // glitch on parent
    parentGlitch(newVal) {
      if (newVal) {
        this.glitch()
      } else {
        this.unglitch()
      }
    }
  },
  data() {
    return {
      glitchStyle1: {},
      glitchStyle2: {},
      storeWatch: null
    }
  },
  methods: {
    // make seperators change scale randomly
    glitch() {
      // helper func to get random scales
      let getStyle = () => {
        const minX = 0.5
        const maxX = 2
        const minY = 0.9
        const maxY = 1.5

        let scaleX = RandomUtils.RandomNumber(minX, maxX)
        let scaleY = RandomUtils.RandomNumber(minY, maxY)
        return {
          transform: `scale(${scaleX},${scaleY})`
        }
      }
      // get two different random ones
      this.glitchStyle1 = getStyle()
      this.glitchStyle2 = getStyle()
    },
    // reset
    unglitch() {
      this.glitchStyle1 = {}
      this.glitchStyle2 = {}
    }
  },
  mounted() {
    this.unglitch()
  },
  created() {
    this.storeWatch = StoreUtils.WatchGlitch(this.glitch, this.unglitch)
  },
  beforeDestroy() {
    this.storeWatch()
  }
}
</script>

<style scoped lang="scss">
@import "@/views/project-synthecite/styles/variables.scss";

.header {
  font-size: min(60px, 5vw);
}

.header-container {
  display: flex;
  margin-top: 100px;
  margin-bottom: 50px;
  justify-content: space-between;
  position: relative;
  font-size: max(20px, min(30px, 4vw));
  transition: 1s opacity;
}

.title-header {
  margin-left: 20px;
  margin-right: 20px;
  max-width: 75%;
  word-break: break-word;
  flex-shrink: 0;
  text-align: center;
}
.seperator {
  height: 5px;
  width: 100%;
  background-color: $text-color;
  transition: 0.5s clip-path;
}

.seperator-wrapper {
  width: 100%;
  margin-top: auto;
  margin-bottom: auto;
}

.title-container {
  margin-left: 10px;
  margin-right: 10px;
}

/** AOS */
[data-aos="appear"] {
  .header-container {
    opacity: 0;
  }

  .seperator.left {
    clip-path: polygon(0 0, 0 0, 0 100%, 0 100%);
  }

  .seperator.right {
    clip-path: polygon(100% 0, 100% 0, 100% 100%, 100% 100%);
  }

  &.aos-animate {
    .header-container {
      opacity: 1;
    }
    .seperator {
      clip-path: polygon(100% 0, 0 0, 0 100%, 100% 100%);
    }
  }
}

/** Responsive */

@media only screen and (max-width: 900px) {
  .header-container {
    margin-bottom: 0px;
  }
}
@media only screen and (min-width: 600px) {
  .header-container {
    font-size: inherit;
  }
}
@media only screen and (max-width: 600px) {
  .header-container {
    font-size: max(30px, 5vw);
  }
}
</style>